import { Box, Text, Button, Inline } from '@machobear/design-system'

type Props = {
  product: {
    id: string
    title: string
    subtitle: string | React.ReactNode
    description: string
    icon: React.FunctionComponent
    onClick?: () => void
    actionText: string
    actionVariant: 'solid' | 'ghost'
    key: string[]
    disabled?: boolean
    detailsText?: string
    detailsOnClick?: () => void
    detailsDisabled?: boolean
  }
}

const ProductCard = ({ product }: Props) => {
  const Icon = product.icon
  return (
    <Box
      borderRadius="large"
      padding="medium"
      gap="xsmall"
      background="neutralLight"
      display="flex"
      flexDirection="column"
      justifyContent="spaceBetween"
      maxWidth="xsmall"
      height="full"
      aria-label={product.title}
      role="listitem"
    >
      <Box display="flex" flexDirection="column" gap="xsmall">
        <Icon />
        <Box display="flex" flexDirection="column" gap="xxxsmall">
          <Text size="medium" weight="strong" baseline={false}>
            {product.title}
          </Text>
          <Text weight="medium" baseline={false} tone="secondary" size="small">
            {product.subtitle}
          </Text>
        </Box>

        <Text baseline={false} tone="secondary" size="small">
          {product.description}
        </Text>
      </Box>
      <Box>
        <Inline space="xsmall">
          <Button
            size="small"
            variant={product.actionVariant}
            onClick={product?.onClick}
            id={product?.id}
            disabled={product?.disabled}
          >
            {product.actionText}
          </Button>
          {product?.detailsText ? (
            <Button
              size="small"
              variant="transparent"
              onClick={product?.detailsOnClick}
              id={product?.id}
              disabled={product?.detailsDisabled}
            >
              {product.detailsText}
            </Button>
          ) : null}
        </Inline>
      </Box>
    </Box>
  )
}

export default ProductCard
